import { NavigationLinkProps } from "../../providers/Router";
import Auth0CallbackPage from "./pages/Auth0CallbackPage";
import Auth0LoginPage from "./pages/Auth0LoginPage";

const AuthenticationRouter: NavigationLinkProps[] = [
  {
    id: "auth0-login-page",
    title: "Login",
    description:
      "Secure authentication with Auth0 multi-factor authentication.",
    path: "/login",
    auth: false,
    component: Auth0LoginPage,
    requiredFeature: [],
    requiredPermissions: ["ANY"],
  },
  {
    id: "auth0-callback-page",
    title: "Auth0 Callback",
    description: "Handles the redirect back from Auth0 after authentication.",
    path: "/auth0-callback",
    auth: false,
    component: Auth0CallbackPage,
    requiredFeature: [],
    requiredPermissions: ["ANY"],
  },
];

export default AuthenticationRouter;
